// Lodash
import _startsWith from 'lodash/startsWith';
export var isNegative = function isNegative(amount) {
  return _startsWith(amount, '-');
};
export var getNumberOrPositiveZeroNumber = function getNumberOrPositiveZeroNumber(value) {
  if (value && Number(value).toFixed(2) === '-0.00') {
    return 0;
  }

  return value;
};
export var roundNumberToNearestMultiple = function roundNumberToNearestMultiple(number, roundToMultipleOf) {
  if (!roundToMultipleOf || number % roundToMultipleOf === 0) return number;
  return Math.ceil(number / roundToMultipleOf) * roundToMultipleOf;
};